import { render, staticRenderFns } from "./CapacityReport.vue?vue&type=template&id=106be380&scoped=true"
import script from "./CapacityReport.vue?vue&type=script&lang=js"
export * from "./CapacityReport.vue?vue&type=script&lang=js"
import style0 from "./CapacityReport.vue?vue&type=style&index=0&id=106be380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106be380",
  null
  
)

export default component.exports